<template>
<div>
  <div class='user_box'>
    <div class='user_title'>我要填表</div>
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{
    
  }
}
</script>

<style lang='less' scoped>
  .user_box{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;  
    height: 100%;
     
    background: #fff;
    overflow: auto;
    .user_title{
      margin-top: 50px;
      margin-left: 100px;
      color:  #0068b7;
      font-size: 28px;
      font-weight: 600;
    }
    .user_info{
      margin-top: 50px;
      margin-left: 122px;
      .info_item{
        display: flex;
        position: relative;
        margin-bottom: 40px;
        .info_item_left{
          width: 161px;
          font-size: 22px;
           
          font-weight: 600;
          height: 28px;
          line-height: 28px;
          color: #666666;
        }
        .info_item_right{
          font-size: 20px;
           
          font-weight: 600;
          height: 28px;
          line-height: 28px;
          color: #333333;
        }
        .icon1{
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .modify{
          position: absolute;
          left: 531px;
          color:  #0068b7;
          height: 28px;
          font-size: 20px;
           
          font-weight: 400;
          line-height: 28px;
          color:  #0068b7;
          opacity: 1;
        }
      }
    }
  }
  .avatar-uploader{
    width: 480px;
    height: 260px;
    background: #FFFFFF;
    border: 1px solid #D0D0D0;
    opacity: 1;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  #avatar1 .el-upload--text,#avatar .el-upload--text{
    margin: 0;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 480px;
    height: 260px;
    line-height: 260px;
    text-align: center;
  }
  .avatar {
    width: 200px;
    height: 200px;
    display: block;
  }
  .user_box::-webkit-scrollbar {    /*滚动条整体样式*/
      width: 10px;                        /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
      display: none;
  }
  .user_box::-webkit-scrollbar-thumb {  /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #ebebeb;
  }
  .user_box::-webkit-scrollbar-track {  /*滚动条里面轨道*/
      /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
      border-radius: 10px;
      background: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/view/help_center/myfill.vue